import { render, staticRenderFns } from "./RegionInputCustom.vue?vue&type=template&id=6aee1de4"
import script from "./RegionInputCustom.vue?vue&type=script&lang=ts"
export * from "./RegionInputCustom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aee1de4')) {
      api.createRecord('6aee1de4', component.options)
    } else {
      api.reload('6aee1de4', component.options)
    }
    module.hot.accept("./RegionInputCustom.vue?vue&type=template&id=6aee1de4", function () {
      api.rerender('6aee1de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/RegionInputCustom.vue"
export default component.exports